import { RootState, RootActions } from "common/reducers";
import { Record } from "immutable";
import { OPEN_OPENINGS_WIZARD, CLOSE_OPENINGS_WIZARD } from "common/reducers/openingsWizard.actions";
import { Nullable } from "common/types";

export const OpeningsWizardStateRecord = Record({
  estimateGroupId: null as Nullable<number>,
  parentProductId: null as Nullable<number>,
  estimateLineItemId: null as Nullable<number>,
});

export const initialState = OpeningsWizardStateRecord();
export type OpeningsWizardState = typeof initialState;

const model = "openingsWizard";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }

  switch (action.type) {
    case OPEN_OPENINGS_WIZARD:
      return state
        .setIn([model, "estimateGroupId"], action.payload.estimateGroupId)
        .setIn([model, "parentProductId"], action.payload.parentProductId)
        .setIn([model, "estimateLineItemId"], action.payload.estimateLineItemId ?? null);

    case CLOSE_OPENINGS_WIZARD:
      return state.setIn([model], initialState);

    default:
      return state;
  }
};
